import ConfigManager from "./ConfigManager";
import googletag from "./googletag";
import GoogletagManager from "./GoogletagManager";
import Logger from "./Logger";
import pbjs from "./pbjs";
import PrebidManager from "./PrebidManager";
import { AuctionConfig, SlotUnion } from "./Types";

export default class Auction {
  slots: SlotUnion[];
  config: Object;
  bidsBackHandler: Function;
  constructor(slots?: SlotUnion[], config?: AuctionConfig) {
    if (slots) this.slots = slots;
    if (config) {
      this.config = config;
      this.bidsBackHandler = config["bidsBackHandler"] || null;
    }
  }

  private getSlots() {
    return this.slots?.map((slot) =>
      typeof slot == "object" ? slot : GoogletagManager.getSlot(slot) || null
    );
  }

  run() {
    googletag().cmd.push(() => {
      PrebidManager.setupAdUnits();

      pbjs().que.push(() => {
        Logger.group(
          `Starting auction for containers ${this.slots?.join(", ")}`
        );
        const slots = this.getSlots();

        GoogletagManager.setGlobalTargeting();
        GoogletagManager.setSlotTargeting();

        Logger.log("codes and slots", this.slots, slots);
        pbjs().requestBids({
          timeout: 1000,
          adUnitCodes: this.slots,
          bidsBackHandler: (bids) => {
            Logger.log("Bids back handler called", bids);
            if (this.bidsBackHandler) {
              Logger.log("Calling custom bid back handler");
              this.bidsBackHandler(bids);
              Logger.log("Returned from custom bid back handler");
            } else {
              Logger.log("setting targeting");
              pbjs().setTargetingForGPTAsync(this.slots);
              Logger.log("Calling refresh slot refresh");

              googletag().pubads().refresh(slots);
            }
            Logger.endGroup();
          },
        });
      });
    });
  }
}
